<template>
    <div
        class="
            shadow-2xl
            rounded-lg
            relative
            group
            text-sm
            md:text-base
            w-[320px]
            h-[280px]
            flex flex-col
        "
        @mouseenter="showTags = true"
        @mouseleave="showTags = false"
    >
        <a :href="hrefNew">
            <div
                class="
                    h-[128px]
                    flex-grow-0 flex-shrink-0
                    relative
                    rounded-t-lg
                "
                :class="{
                    'bg-accent': isLive,
                    'bg-cngray-300': !isLive,
                }"
            >
                <div class="absolute top-4 left-4 flex items-center gap-2">
                    <div
                        class="
                            bg-red-500
                            text-white
                            py-1
                            px-2
                            text-sm
                            rounded-lg
                        "
                        v-if="isLive"
                    >
                        Live
                    </div>
                    <div
                        class="flex items-center -space-x-3 my-2 justify-center"
                    >
                        <img
                            v-for="user in users"
                            :src="user.avatar"
                            :key="user.id"
                            class="
                                w-6
                                h-6
                                rounded-full
                                border border-solid border-accent
                                aspect-square
                                object-cover
                            "
                            :alt="user.name"
                        />
                    </div>
                </div>
                <div class="absolute right-4 bottom-4 text-xl text-gray-50">
                    <img
                        src="/default-images/icons/bolt.svg"
                        alt="Offense"
                        v-if="room.category === 'offense'"
                    />
                    <img
                        src="/default-images/icons/shield-check.svg"
                        alt="Defense"
                        v-if="room.category === 'defense'"
                    />
                    <img
                        src="/default-images/icons/field-goal.svg"
                        alt="Special"
                        v-if="room.category === 'special'"
                    />
                    <span v-if="room.category === 'free'"> Free </span>
                </div>
            </div>
        </a>

        <div class="p-4 flex items-center bg-white gap-2">
            <div
                class="py-1 px-2 rounded-lg text-sm"
                :style="{
                    background: colorForCategory(room.category).bg,
                    color: colorForCategory(room.category).text,
                }"
            >
                <div
                    class="flex items-center gap-2"
                    v-if="room.category === 'free'"
                >
                    Free
                </div>
                <div
                    class="flex items-center gap-2"
                    v-if="room.category === 'offense'"
                >
                    <img
                        src="/default-images/icons/bolt-solid.svg"
                        alt="Offense"
                    />
                    Offense
                </div>
                <div
                    class="flex items-center gap-2"
                    v-if="room.category === 'defense'"
                >
                    <img
                        src="/default-images/icons/shield-solid.svg"
                        alt="Defense"
                    />
                    Defense
                </div>
                <div
                    class="flex items-center gap-2"
                    v-if="room.category === 'special'"
                >
                    <img
                        src="/default-images/icons/field-goal-solid.svg"
                        alt="Special"
                    />
                    Special Team
                </div>
            </div>
            <button
                class="
                    ml-auto
                    bg-transparent
                    p-1.5
                    rounded-lg
                    hover:bg-gray-100
                "
                @click="openShare"
            >
                <img src="/default-images/icons/link.svg" alt="Link" />
            </button>
            <context-menu class="text-xl" v-if="canManage && hrefNew">
                <li>
                    <a
                        class="
                            py-1
                            pl-4
                            pr-8
                            flex flex-row
                            items-center
                            text-left
                            gap-2
                            cursor-pointer
                            hover:bg-gray-300
                            rounded-lg
                        "
                        :href="href"
                    >
                        <ion-icon name="basketball-outline"></ion-icon>
                        <div class="flex-grow-1 flex-shrink-0 font-slab mt-1">
                            Old whiteboard
                        </div>
                    </a>
                </li>
                <li>
                    <a
                        class="
                            py-1
                            pl-4
                            pr-8
                            flex flex-row
                            items-center
                            text-left
                            gap-2
                            cursor-pointer
                            hover:bg-gray-300
                            rounded-lg
                        "
                        @click="isOpen = true"
                    >
                        <ion-icon name="create-outline"></ion-icon>
                        <div class="flex-grow-1 flex-shrink-0 font-slab mt-1">
                            Edit
                        </div>
                    </a>
                </li>
                <li @click="$refs.deleteForm.submit()">
                    <form :action="deleteApi" method="post" ref="deleteForm">
                        <input
                            type="hidden"
                            name="_token"
                            :value="$root.csrfToken"
                        />
                        <input
                            type="hidden"
                            name="room_id"
                            :value="room.room_id"
                        />
                        <div
                            class="
                                py-1
                                pl-4
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                                text-red-500
                            "
                        >
                            <ion-icon name="trash-outline"></ion-icon>
                            <button
                                type="submit"
                                class="flex-grow-1 flex-shrink-0 font-slab mt-1"
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </li>
            </context-menu>
        </div>
        <a
            :href="hrefNew"
            class="
                flex flex-col flex-grow flex-shrink
                px-4
                pb-4
                bg-white
                rounded-b-lg
            "
        >
            <h3
                class="
                    text-sm
                    font-[600]
                    md:text-2xl
                    flex-grow-1 flex-shrink-0
                    truncate
                "
            >
                {{ room.room_name }}
            </h3>
            <p class="text-sm text-gray-500">
                Created at {{ new Date(room.created_at).toLocaleDateString() }}
            </p>
        </a>
        <div class="absolute right-0 bottom-[-10px]" v-if="showTags">
            <div
                v-for="tag in room.tags"
                :key="tag.id"
                class="
                    text-md
                    p-2
                    rounded-full
                    inline-flex
                    items-center
                    w-auto
                    gap-2
                    cursor-pointer
                    opacity-100
                    hover:opacity-75
                "
                :style="{
                    background: tag.color,
                    color: isDark(tag.color) ? '#fff' : '#000',
                }"
            >
                <img
                    v-if="tag.icon_type === 'upload'"
                    :src="tag.icon"
                    alt=""
                    class="w-[15px] h-[15px]"
                />
                <div v-if="tag.icon_type === 'emoji'">{{ tag.icon }}</div>
                <ion-icon
                    v-if="tag.icon_type === 'ionicons'"
                    :name="tag.icon"
                ></ion-icon>
            </div>
        </div>

        <ModalCustom
            :is-open="isOpen"
            title="Update Room"
            @close="isOpen = false"
        >
            <form :action="updateApi" method="post">
                <input type="hidden" name="team_id" :value="teamId" />
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="room_id" :value="room.room_id" />

                <div class="my-2">
                    <new-input
                        type="text"
                        name="room_name"
                        placeholder="Room Name"
                        :value="room.room_name"
                        maxlength="20"
                        required
                    ></new-input>
                </div>
                <div class="my-2" v-if="canEditCategory">
                    <new-autoselect
                        name="category"
                        v-model="category"
                        :options="[
                            { value: 'offense', label: 'Offense' },
                            { value: 'defense', label: 'Defense' },
                            { value: 'special', label: 'Special' },
                        ]"
                        placeholder="Category"
                        required
                    ></new-autoselect>
                </div>

                <div class="mt-4">
                    <div class="mb-2 font-bold">Access</div>
                    <div class="flex gap-2">
                        <TagForm
                            :tags="room.tags"
                            :available-tags="availableTags"
                        ></TagForm>
                    </div>
                </div>
                <div class="mt-4 text-right">
                    <app-button type="submit"> Save</app-button>
                </div>
            </form>
        </ModalCustom>

        <ModalCustom
            :is-open="share.isShareOpen"
            title="Share "
            @close="share.isShareOpen = false"
        >
            <div class="flex items-center bg-gray-200 rounded p-2 gap-2">
                <input
                    type="text"
                    class="w-full w-max-[240px] bg-transparent outline-none"
                    :value="shareLink"
                    readonly
                    @click="$event.target.select()"
                />
                <button
                    class="bg-gray-300 rounded p-2"
                    @click="copyToClipboard"
                    title="Copy to clipboard"
                >
                    <ion-icon name="copy-outline"></ion-icon>
                </button>
            </div>
            <div
                v-if="isCopied"
                class="
                    bg-gray-900
                    p-2
                    rounded
                    text-white text-xs
                    my-4
                    inline-block
                "
            >
                Link Copied
            </div>

            <div class="mt-4">
                <input
                    type="checkbox"
                    :readonly="share.isGenerating"
                    id="share_is_public"
                    v-model="share.isPublic"
                    @change="updateShareVisibility"
                />
                <label for="share_is_public">
                    <span class="ml-2">Public</span>
                </label>
            </div>
        </ModalCustom>
    </div>
</template>

<script>
import ModalCustom from "./ModalCustom";
import SimpleLoadingCircle from "./SimpleLoadingCircle.vue";
import NewAutoselect from "./forms/NewAutoselect.vue";
import NewInput from "./forms/NewInput.vue";
import { isDark } from "./forms/utils";

export default {
    name: "RoomCard",
    components: { NewInput, NewAutoselect, SimpleLoadingCircle, ModalCustom },
    props: [
        "updateApi",
        "deleteApi",
        "room",
        "teamId",
        "href",
        "hrefNew",
        "liveApi",
        "liveOnly",
        "canEditCategory",
        "canManage",
        "availableTags",
    ],
    data() {
        return {
            isOpen: false,
            isCopied: false,
            isLive: false,
            users: [],
            isLoading: false,
            category: this.room.category,
            showTags: false,
            share: {
                isSharing: false,
                isPublic: false,
                isShareOpen: false,
            },
        };
    },
    mounted() {
        this.isLive = this.room.live_data.status === "live";
        this.users = this.room.live_data.users;
    },
    watch: {
        room: {
            handler(newVal) {
                this.isLive = newVal.live_data.status === "live";
                this.users = newVal.live_data.users;
                this.category = newVal.category;
            },
            deep: true,
        },
    },
    computed: {
        shareLink() {
            if (this.share.isPublic) {
                return this.share.link;
            }
            return this.hrefNew;
        },
    },
    methods: {
        isDark: isDark,
        handleSubmit() {},
        copyToClipboard() {
            navigator.clipboard.writeText(this.hrefNew);
            this.isCopied = true;
        },
        colorForCategory(category) {
            switch (category) {
                case "offense":
                    return {
                        bg: "#7BA9571A",
                        text: "#7BA957",
                    };
                case "defense":
                    return {
                        bg: "#FF5C831A",
                        text: "#FF5C83",
                    };
                case "special":
                    return {
                        bg: "#5CC4FF1A",
                        text: "#5CC4FF",
                    };
                case "free":
                    return {
                        bg: "#DDD",
                        text: "#555",
                    };
            }
        },
        openShare() {
            this.share.isShareOpen = true;
            console.log({ a: this.room });
            axios
                .get(
                    `/shared-link?resource_type=meetings&resource_id=${this.room.room_id}`
                )
                .then((response) => {
                    if (response.data?.visibility) {
                        this.share.isPublic = true;
                        this.share.link = response.data.link;
                    }
                });
        },
        async updateShareVisibility() {
            this.share.isGenerating = true;
            if (this.share.isPublic) {
                axios
                    .post("/shared-link/create", {
                        resource_type: "meetings",
                        resource_id: this.room.room_id,
                    })
                    .then((response) => {
                        this.share.isGenerating = false;
                        this.share.link = response.data.link;
                        this.share.token = response.data.data.token;
                        this.share.isPublic =
                            response.data.data.visibility === "public";
                        this.share.isLoaded = true;
                    })
                    .catch((error) => {
                        this.share.isGenerating = false;
                        console.log(error);
                    });

                this.share.isGenerating = false;
            } else {
                axios
                    .post("/shared-link/remove", {
                        resource_type: "meetings",
                        resource_id: this.room.room_id,
                    })
                    .then((response) => {
                        this.share.isGenerating = false;
                        this.share.isPublic = false;
                    })
                    .catch((error) => {
                        this.share.isGenerating = false;
                        console.log(error);
                    });

                this.share.isGenerating = false;
            }
        },
    },
};
</script>

<style scoped></style>
